import React from 'react';

/* Фирменный лоадер: знак ИНФА СОТКА в брендовом фиолетовом «дышит» со
   свечением, вокруг — тонкий вращающийся ободок. Стили — в App.css (.ldr*).
   Маска логотипа задаётся здесь через PUBLIC_URL (в CSS webpack пытается
   резолвить путь как модуль и сборка падает). */
const MASK = `url(${process.env.PUBLIC_URL || ''}/landing/logo-mark.png)`;

export default function Loader({ text = 'Загрузка…' }) {
  return (
    <div className="ldr">
      <div className="ldr-orb">
        <div className="ldr-ring" />
        <div className="ldr-mark" style={{ WebkitMaskImage: MASK, maskImage: MASK }} />
      </div>
      {text && <div className="ldr-txt">{text}</div>}
    </div>
  );
}
